import { makeStyles } from '@material-ui/core/styles';

const NAVY = '#0E1247';

export default makeStyles({
  snackbar: {
    bottom: 24,
    right: 24,
  },
  successToast: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    background: NAVY,
    borderRadius: 8,
    padding: '14px 20px',
    boxShadow: '0 8px 24px rgba(14, 18, 71, 0.28)',
    maxWidth: 420,
  },
  successIcon: {
    width: 22,
    height: 22,
    borderRadius: '50%',
    background: '#FFFFFF',
    color: NAVY,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  successMessage: {
    fontFamily: 'Poppins, sans-serif',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.4,
    color: '#FFFFFF',
  },
});
